import { useEffect, useState } from 'react';
import axios from 'axios';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Chandrabalam.scss';
import Footer from '../../../components/Footer/Footer';
import PanchangLinks from '../../../components/PanchangLinks/PanchangLinks';
import city from '../../../city.json'


const Chandrabalam = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  const [dob, setDob] = useState("2004-03-16");
  const [timeFormat, setTimeFormat] = useState("12");
  const [chandrabalaData, setChandrabalaData] = useState(null);

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;


     // Temporary states for user input for submit button and location dropdown
     const [tempDate, setTempDate] = useState(currentDate);
     const [tempLocation, setTempLocation] = useState("Kolkata");
     const [suggestions, setSuggestions] = useState([]);

  const fetchChandrabala = async () => {
    try {
      const res = await axios.get(
        `https://core-c343.onrender.com/api/chandrabala`,
        {
          params: {
            location: location.toLowerCase(),
            date: formattedDate,
            dob,
            tob: "05:00",
            name: "user"
          }
        }
      );
      setChandrabalaData(res.data);
    } catch (err) {
      console.error("Error fetching chandrabala data:", err);
      setChandrabalaData(null);
    }
  };

  useEffect(() => {
    fetchChandrabala();
  }, [location, formattedDate, dob]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};


  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  return (
    <div className="Chandrabalam-container">
      <InnerNav />
      <div className="Chandrabalam-content">
        <Zodiac />

        <div className="controls">
          <div className="mode-toggle">
            <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
            <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
            <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
          </div>

          <div className="month-grid">
            {months.map((month, i) => (
              <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
            ))}
          </div>

          <div className="day-grid">
            {Array.from({ length: 31 }, (_, i) => (
              <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
            ))}
          </div>

          <div className="location-date">
                  <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
        </div>

        <div className="zodiac-info">
          <div className="zodiac-header">
            <h2 className="date">{readableDate}</h2>
            <div className="DoB">
              <h3>Enter Your DOB</h3>
              <input type="date" value={dob} onChange={(e) => setDob(e.target.value)} />
            </div>
          </div>

          {chandrabalaData ? (
            <div className="result-section">
              <h3>Moon Sign Today: <span>{chandrabalaData.moonSignToday}</span></h3>
              <h3>Your Rashi: <span>{chandrabalaData.userRashi}</span></h3>
              <h3>Favorable Status: <span className={`status ${chandrabalaData.favorable.toLowerCase()}`}>
                {chandrabalaData.favorable}
              </span></h3>
            </div>
          ) : (
            <p>Loading Chandrabalam data...</p>
          )}
        </div>

        <PanchangLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Chandrabalam;
